export function addButtonListeners() {
    if (this.buttonElement) {
        // Store the click handler reference so we can remove it later
        this.buttonClickHandler = () => {
            // Change button text to loading state
            const buttonText = this.buttonElement.querySelector('button');
            if (buttonText) {
                buttonText.textContent = this.settings.loadingText;
            }
            
            this.direction = 'next';
            this.loadContent();
        };
        
        this.buttonElement.addEventListener('click', this.buttonClickHandler);
    }
}